'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (entity, text, options) {
  var hash = text.substring(entity.indices[0], entity.indices[0] + 1);
  var hashtag = (0, _htmlEscape2.default)(entity.hashtag);
  var attrs = (0, _clone2.default)(options.htmlAttrs || {});
  attrs.href = options.hashtagUrlBase + hashtag;
  attrs.title = '#' + hashtag;
  attrs['class'] = options.hashtagClass;
  if (hashtag.charAt(0).match(_rtlChars2.default)) {
    attrs['class'] += ' rtl';
  }
  if (options.targetBlank) {
    attrs.target = '_blank';
  }

  return (0, _linkToTextWithSymbol2.default)(entity, hash, hashtag, attrs, options);
};

var _clone = require('./lib/clone');

var _clone2 = _interopRequireDefault(_clone);

var _htmlEscape = require('./htmlEscape');

var _htmlEscape2 = _interopRequireDefault(_htmlEscape);

var _rtlChars = require('./regexp/rtlChars');

var _rtlChars2 = _interopRequireDefault(_rtlChars);

var _linkToTextWithSymbol = require('./linkToTextWithSymbol');

var _linkToTextWithSymbol2 = _interopRequireDefault(_linkToTextWithSymbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default']; // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0